export const TEXT_IMAGE_TO_VIDEO_TOOL_DEFAULT_VIDEO_PATH =
  'https://replai-public-assets.s3.amazonaws.com/creative-generation/default-assets/text-image-to-video.mp4';
export const TEXT_VIDEO_TO_VIDEO_TOOL_DEFAULT_VIDEO_PATH =
  'https://replai-public-assets.s3.amazonaws.com/creative-generation/default-assets/text-video-to-video.mp4';
export const CHARACTER_TO_VIDEO_TOOL_DEFAULT_VIDEO_PATH =
  'https://replai-public-assets.s3.amazonaws.com/creative-generation/default-assets/character-to-video.mp4';
export const TEXT_IMAGE_TO_IMAGE_TOOL_DEFAULT_IMAGE_PATH =
  'https://replai-public-assets.s3.amazonaws.com/creative-generation/default-assets/text-image-to-image-thumbnail.png';
